"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tableLayouts = void 0;
var tableLayouts = {
  fixed: {
    tableLayout: 'fixed'
  },
  auto: {
    tableLayout: 'auto'
  }
};
exports.tableLayouts = tableLayouts;